export default function TermsPage() {
  return (
    <section className="legal">
      <h1>Terms of Service</h1>
      <p className="muted">Last updated: 2026. Please review these terms with your own counsel before relying on them.</p>

      <h2>1. About NYGTIX</h2>
      <p>
        NYGTIX is an independent peer-to-peer marketplace that lets verified New York Giants Season
        Ticket Holders resell individual game tickets for home games at MetLife Stadium. NYGTIX is
        not affiliated with, endorsed by, or sponsored by the New York Giants, the NFL, MetLife
        Stadium, or Ticketmaster. NYGTIX is a venue for transactions between buyers and sellers; we
        are not the seller of any ticket.
      </p>

      <h2>2. Accounts</h2>
      <p>
        Buyers create a free account with a verified email. Sellers must apply, pass seat
        verification, and complete Stripe payouts onboarding before listing. You are responsible for
        the accuracy of the information you provide and for activity on your account.
      </p>

      <h2>3. Listings and seller obligations</h2>
      <p>
        Sellers may only list seats they actually hold and that NYGTIX has verified. After a sale,
        the seller must transfer the tickets to the buyer through the official Giants/Ticketmaster
        platform within 24 hours and mark them transferred in NYGTIX. Listing tickets you do not
        control, or failing to deliver after a sale, may result in refunds to the buyer and
        suspension of your account.
      </p>

      <h2>4. Payments, escrow, and fees</h2>
      <p>
        Buyers pay at checkout and funds are held by NYGTIX in escrow. Funds are released to the
        seller after the buyer confirms receipt, or automatically 48 hours after the seller marks
        the tickets transferred. Sellers pay a 5% platform fee, deducted from the payout. Buyers pay
        no platform fee. All amounts are in U.S. dollars and processed by Stripe.
      </p>

      <h2>5. Disputes and refunds</h2>
      <p>
        If tickets are not received, a buyer may open a dispute while funds are in escrow and no
        later than 48 hours after the game. NYGTIX reviews disputes and may refund the buyer from
        escrow, reversing any payout already made to the seller. See our{' '}
        <a href="/legal/buyer-protection">Buyer Protection</a> policy.
      </p>

      <h2>6. Prohibited conduct</h2>
      <p>
        No fraudulent, duplicate, or speculative listings; no circumventing escrow or fees; no
        unlawful resale where prohibited. We may cancel listings, hold funds, or suspend accounts to
        enforce these terms.
      </p>

      <h2>7. Disclaimers and liability</h2>
      <p>
        The service is provided "as is." To the extent permitted by law, NYGTIX is not liable for
        indirect or consequential damages, and our aggregate liability for any transaction is limited
        to the platform fee we collected on it.
      </p>

      <h2>8. Changes</h2>
      <p>We may update these terms; continued use constitutes acceptance of the current version.</p>
    </section>
  );
}
